import { useSitecoreContext } from 'hooks/useSitecoreContext';
import { ComponentProps } from 'lib/component-props';
import NextStepsCommon from 'components/Pages/ArticleParts/NextStepsCommon';
import { useI18n } from 'next-localization';
import { useEffect, useState } from 'react';
import findComponentInTree from 'lib/utils/findComponentInTree';

const HelpNextSteps = ({ rendering, params }: ComponentProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const { t } = useI18n();

  const [relatedHelpPlatformComponent, setRelatedHelpPlatformComponent] = useState(false);

  useEffect(() => {
    const routeData = sitecoreContext.route;
    if (routeData?.placeholders['abrdn-main']) {
      const relatedHelpPlatform = findComponentInTree(
        routeData?.placeholders['abrdn-main'],
        'RelatedHelpPlatform'
      );
      setRelatedHelpPlatformComponent(!!relatedHelpPlatform);
    }
  }, [sitecoreContext.route]);

  return (
    (relatedHelpPlatformComponent || sitecoreContext.pageEditing) && (
      <NextStepsCommon
        className="mt-5"
        rendering={rendering}
        params={params}
        title={t('helpNextStepsTitle')}
        description={t('helpNextStepsDescription')}
        placeholderName="abrdn-help-article-next-steps-content"
      />
    )
  );
};

export default HelpNextSteps;
